<template>
  <vue-html2pdf
    :show-layout="false"
    :float-layout="false"
    :enable-download="true"
    :preview-modal="true"
    :paginate-elements-by-height="1400"
    pdf-content-width="480px"
    :filename="fileName"
    :pdf-quality="2"
    :manual-pagination="false"
    pdf-format="a4"
    pdf-orientation="portrait"
    ref="html2Pdf"
    :html-to-pdf-options="htmlToPdfOptions"
    @hasDownloaded="hasDownloaded()"
  >
    <template slot="pdf-content">
      <div>
      <div
        class="product-card"
        :style="{'--background': vg_activeBusinessBrandingAndLogo.primary}"
        v-for="(item, index) in productsData" :key="index"
      >
        <Product-qr-ui-variant v-bind:key="'pdf-card-full'+variant.id" v-for="variant in item.variants"  :variant="variant" :product="item" :qrCodeValue="getQrCodeValue(item)" :isPdf="true" />
      </div>
      </div>
    </template>
  </vue-html2pdf>
  <!--  <product-qr-ui :product="item" :isPdf="true" :qrCodeValue="getQrCodeValue(item)"/>-->
</template>

<script>
import ProductQrUi from '@/components/app-specific/ProductQrUi.vue'
import ProductQrUiVariant from '@/components/app-specific/ProductQrUiVariant.vue'
import VueHtml2pdf from 'vue-html2pdf'
import { mapGetters } from 'vuex'
export default {
  name: 'QrToHtml',
  components: {
    ProductQrUi,
    VueHtml2pdf,
    ProductQrUiVariant
  },
  props: ['productsData'],
  computed: {
    ...mapGetters({
      vg_activeBusinessBrandingAndLogo: 'auth/activeBusinessBrandingAndLogo',
      vg_selectedLocation: 'location/selected',
      vg_selectedBusiness: 'auth/activeBusiness'
    }),
    htmlToPdfOptions() {
      return {
        margin: [2, 0, 0, 0],
        filename: `${this.fileName}.pdf`,
        // image: { type: 'png', quality: 1 },
        html2canvas: {
          scrollX: 0,
          scrollY: 0,
          useCORS: true,
          dpi: 192,
          scale: 2,
          letterRendering: true
        }
      }
    },
    fileName() {
      return `products-card.pdf`
    }
  },
  methods: {
    getQrCodeValue(item) {
      return (
        process.env.VUE_APP_PRODUCT_QR_URL + '/' +
        this.vg_selectedBusiness.slug +
        '/' +
        this.vg_selectedLocation.slug +
        '/' +
        item.id +
        '?in_store=true&noage=true'
      )
    },
    hasDownloaded() {
      this.$emit('hasDownloaded')
    },
    generatePdf() {
      this.$refs.html2Pdf.generatePdf()
    }
  }
}
</script>
